import { DEFAULT_EMAIL_DOMAIN, DEFAULT_USERNAME } from "./constants";

/**
 * Constructs a Costco email from username
 */
export const buildCostcoEmail = (
  username: string | undefined | null,
): string => {
  const sanitizedUsername = username?.trim() || DEFAULT_USERNAME;
  return `${sanitizedUsername}${DEFAULT_EMAIL_DOMAIN}`;
};

/**
 * Type guard to check if data is DefaultThreshold
 */
export const isDefaultThreshold = (
  data: unknown,
): data is { thresholdDefaultId: number } => {
  return (
    typeof data === "object" && data !== null && "thresholdDefaultId" in data
  );
};

/**
 * Type guard to check if data is CommodityThreshold
 */
export const isCommodityThreshold = (
  data: unknown,
): data is { commodityThresholdId: number } => {
  return (
    typeof data === "object" && data !== null && "commodityThresholdId" in data
  );
};

/**
 * Convert threshold mediumMin/lowMin value to slider index (0-9)
 * mediumMin represents the left handle position
 * lowMin represents the right handle position
 */
export const thresholdToIndex = (value: number): number => {
  // Round down to get the base index (e.g., 3.00 -> 2, 7.00 -> 6)
  const index = Math.floor(value) - 1;
  return Math.max(0, Math.min(9, index));
};

/**
 * Convert slider index to actual threshold boundary values
 * Returns the min value for that boundary (e.g., index 2 -> 3.00)
 */
export const indexToThresholdMin = (index: number): number => {
  return parseFloat((index + 1.0).toFixed(2));
};

/**
 * Calculate highMax from mediumMin (mediumMin - 0.01)
 */
export const calculateHighMax = (mediumMin: number): number => {
  return parseFloat((mediumMin - 0.01).toFixed(2));
};

/**
 * Calculate mediumMax from lowMin (lowMin - 0.01)
 */
export const calculateMediumMax = (lowMin: number): number => {
  return parseFloat((lowMin - 0.01).toFixed(2));
};
